<div class="inner-content" ridangoAppTrapFocus>
    <div class="!flex h-full flex-col justify-center text-base">
        <div class="solid-border rounded-2xl border-2 bg-white dark:border-contrast-yellow">
            <div class="flex-align-center relative relative flex h-10 justify-center p-4">
                <p class="font-semibold">{{ 'TRANSFER_ANONYMOUS_TITLE' | translate }}</p>
                <button
                    class="!absolute !right-2"
                    [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                    (click)="cancel()"
                    mat-icon-button
                    aria-label="close">
                    <mat-icon class="close-button font-bold">close</mat-icon>
                </button>
            </div>
            <div class="content px-4">
                <p>{{ 'TRANSFER_ANONYMOUS_DESCRIPTION_0' | translate }}</p>
                <p class="mt-4">{{ 'TRANSFER_ANONYMOUS_DESCRIPTION_1' | translate }}</p>
            </div>
            <div class="p-4">
                <div class="rounded-lg bg-grey-white_smoke p-4 dark:bg-contrast-black">
                    <p class="text-lg font-bold">
                        {{ 'DATA_THAT_WILL_BE_DELETED' | translate }}
                    </p>
                    <ul>
                        <li>{{ 'YOUR_TICKETS1' | translate }}</li>
                        <li>{{ 'PURCHASE_HISTORY_TRANSFER' | translate }}</li>
                    </ul>
                </div>
                <div class="border-ironside_grey-100 mt-4 border-t border-solid">
                    <button
                        class="btn--link btn--maximal btn--big link--no-line link--no-hover ng-star-inserted sr-app-light:h-16 sr-app-light:text-[1rem] mt-4 rounded-lg text-base text-primary dark:text-contrast-yellow"
                        (click)="cancel()">
                        {{ 'CANCEL' | translate }}
                    </button>
                    <button
                        class="btn--link btn btn--maximal btn--primary btn--big link--no-line link--no-hover sr-app-light:text-white sr-app-light:h-16 sr-app-light:text-[1rem] mt-4 rounded-lg text-base font-bold"
                        (click)="confirm()">
                        {{ 'TRANSFER' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
